import React from "react";

export default function Footer() {
  return (
    <div className="footer">
      <a
        href="https://github.com/annabananallama/weather-react"
        rel="noreferrer"
        target="_blank"
      >
        <strong>Open source code </strong>
      </a>
      by Anna Larsen
    </div>
  );
}
